import { forwardRef } from 'react';
import { cn } from '../../util';

interface TableHeadProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
  className?: string;
}

const TableHead = forwardRef<HTMLTableCellElement, TableHeadProps>(({ className, ...props }, ref) => (
  <th
    ref={ref}
    className={cn(
      'text-muted-foreground h-10 text-left align-middle font-bold [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px] [table[data-compact]_&]:h-8 [table[data-compact]_&]:text-sm',
      className
    )}
    {...props}
  />
));

TableHead.displayName = 'TableHead';

export default TableHead;
